// Based on CRA PWA template
export function register() {
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      const swUrl = "/service-worker.js";

      navigator.serviceWorker
        .register(swUrl)
        .then((registration) => {
          // console.log("ServiceWorker registered successfully: ", registration);

          // Check for updates
          registration.addEventListener("updatefound", () => {
            console.log("ServiceWorker update found");
          });
        })
        .catch((error) => {
          console.error("ServiceWorker registration failed: ", error);
          // Don't break the app if service worker fails
        });
    });
  } else {
    console.log("ServiceWorker not supported in this browser");
  }
}

export function unregister() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready.then((registration) => {
      registration.unregister();
    });
  }
}
